export class InvoiceSelectors {
  static cutoffDate = 'cutoffDate';
}
